import * as React from "react";
import "./styles.scss";

interface CensusLabelValueProps {
    label: string,
    value: string,
    valueClassName?: string,
    labelClassName?: string
    rootClassName?: string
}

export const CensusLabelValue: React.FC<CensusLabelValueProps> = ({
                                                                      rootClassName,
                                                                      label,
                                                                      labelClassName,
                                                                      valueClassName,
                                                                      value
                                                                  }) => {
    return (
        <p className={"label-value " + (rootClassName ?? "")}>
            <span className={"padding-bottom-3 " + labelClassName ?? ""}>{label}</span>
            <span className={"padding-bottom-3 ellipsis " + (valueClassName ?? "")}>{value}</span>
        </p>
    );
}